import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { IconButton, Tooltip, Box, Button, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ViewListIcon from "@mui/icons-material/ViewList";
import AddIcon from "@mui/icons-material/Add";

export const getVehicleModelsDataColumns = ({
  onEdit = () => {},
  onDelete = () => {},
  onAddTrim = () => {},
  onViewTrims = () => {},
} = {}) => [
  {
    field: "name",
    headerName: "Model Name",
    width: 200,
    renderCell: (params) => (
      <Tooltip title={params?.value}>
        <Button
          size="medium"
          sx={{ justifyContent: "flex-start", textTransform: "none" }}
          component={RouterLink}
          to={`/models/${params.row.modelId}`}
        >
          {params?.value}
        </Button>
      </Tooltip>
    ),
  },
  {
    field: "modelYear",
    headerName: "Year",
    width: 100,
  },
  {
    field: "region",
    headerName: "Region",
    width: 120,
  },
  {
    field: "createdAt",
    headerName: "Created Date",
    width: 180,
    renderCell: (params) => {
      if (!params.value) return null;
      const date = new Date(params.value);
      return (
        <span>
          {date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
          <br />
          <span style={{ color: "#888", fontSize: "0.75rem" }}>
            {date.toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </span>
      );
    },
  },
  {
    field: "updatedAt",
    headerName: "Updated Date",
    width: 180,
    renderCell: (params) => {
      if (!params.value) return null;
      const date = new Date(params.value);
      return (
        <span>
          {date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
          <br />
          <span style={{ color: "#888", fontSize: "0.75rem" }}>
            {date.toLocaleTimeString("en-US", {
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </span>
      );
    },
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 320,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="View Trims">
            <Button
              size="small"
              variant="outlined"
              color="primary"
              startIcon={<ViewListIcon />}
              onClick={(e) => {
                e.stopPropagation();
                onViewTrims(params.row);
              }}
              sx={{ textTransform: "none", fontSize: "0.875rem" }}
            >
              Trims
            </Button>
          </Tooltip>
          <Tooltip title="Add Trim">
            <Button
              size="small"
              variant="outlined"
              color="primary"
              startIcon={<AddIcon />}
              onClick={(e) => {
                e.stopPropagation();
                onAddTrim(params.row);
              }}
              sx={{ textTransform: "none", fontSize: "0.875rem" }}
            >
              Add
            </Button>
          </Tooltip>
        </Stack>
        <Stack direction="row" spacing={0}>
          {/* <Tooltip title="Edit">
            <IconButton
              size="small"
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(params.row);
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip> */}
          <Tooltip title="Delete">
            <IconButton
              size="small"
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(params.row);
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>
    ),
  },
];